// extracted by mini-css-extract-plugin
module.exports = {"Link":"LinkComponent_Link__1Isqx","Left":"LinkComponent_Left__2mpgU","Logo":"LinkComponent_Logo__1fazU","NavigationItem":"LinkComponent_NavigationItem__wQcEX"};